module.exports = __webpack_public_path__ + "static/img/1.ad4ecab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newOne/1.png
// module id = rF3U
// module chunks = 0